<template>
  <div class="mr-7 font-weight-bold">
    <span class="hidden-md-and-down" :class="h2Class">Time now </span>
    <span class="font-weight-bold" :class="h1Class">{{ formattedTime }}</span>
  </div>
</template>

<script>
export default {
  inject: ["h1Class", "h2Class"],
  name: "TimeNow",
  props: {
    timeZone: {
      type: String,
      default: "UTC", // Default to UTC if no timezone is provided
    },
  },
  data() {
    return {
      formattedTime: "",
      intervalId: null,
    };
  },
  mounted() {
    clearInterval(this.intervalId);
    this.updateTime();
    this.intervalId = setInterval(this.updateTime, 5000); // Update time every 5 seconds
  },
  methods: {
    updateTime() {
      const currentTime = new Date();
      this.formattedTime = new Intl.DateTimeFormat("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
        timeZone: this.timeZone,
      }).format(currentTime);
    },
  },
  beforeDestroy() {
    clearInterval(this.intervalId); // Clear the interval when component is destroyed
  },
};
</script>

<style scoped></style>
